import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import Form from '../../../containers/Form/Form'
import Button from '../../../containers/Form/Button'

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_geo_subpid_list, tool_geo_subpid_save } from "../../../app/apiEndpoints"
import { Card, Row, Col, FormControl, Breadcrumb } from 'react-bootstrap'
import Select from '../../../containers/Form/Select'
import Input from '../../../containers/Form/Input'
import CascadeToolToggle from '../../../containers/CascadeToolToggle';
import ConfirmDialog from '../../../containers/ConfirmDialog';


const GeoDefaultSubpidTool = (props) => {
    const toolID = 20
    const [tool, setTool] = useState({})
    const [paths, setPaths] = useState(Array(10).fill(0))

    const [cascadeType, setCascadeType] = useState(0)
    const [cascadeError, setCascadeError] = useState("")

    const [mobileValues, setMobileValues] = useState({ 
        order1: 1, weight1: 10, path1: '0', 
        order2: 0, weight2: 10, path2: '0', 
        order3: 0, weight3: 10, path3: '0', 
        order4: 0, weight4: 10, path4: '0', 
        order5: 0, weight5: 10, path5: '0', 
        order6: 0, weight6: 10, path6: '0', 
        order7: 0, weight7: 10, path7: '0', 
        order8: 0, weight8: 10, path8: '0', 
        order9: 0, weight9: 10, path9: '0', 
        order10: 0, weight10: 10, path10: '0' });
    const [desktopValues, setDesktopValues] = useState({ 
        order1: 1, weight1: 10, path1: '0', 
        order2: 0, weight2: 10, path2: '0', 
        order3: 0, weight3: 10, path3: '0', 
        order4: 0, weight4: 10, path4: '0', 
        order5: 0, weight5: 10, path5: '0', 
        order6: 0, weight6: 10, path6: '0', 
        order7: 0, weight7: 10, path7: '0', 
        order8: 0, weight8: 10, path8: '0', 
        order9: 0, weight9: 10, path9: '0', 
        order10: 0, weight10: 10, path10: '0' });
    const [errors, setErrors] = useState({ 
        m_order1: "", m_weight1: "", m_path1: "", 
        m_order2: "", m_weight2: "", m_path2: "", 
        m_order3: "", m_weight3: "", m_path3: "", 
        m_order4: "", m_weight4: "", m_path4: "", 
        m_order5: "", m_weight5: "", m_path5: "", 
        m_order6: "", m_weight6: "", m_path6: "", 
        m_order7: "", m_weight7: "", m_path7: "", 
        m_order8: "", m_weight8: "", m_path8: "", 
        m_order9: "", m_weight9: "", m_path9: "", 
        m_order10: "", m_weight10: "", m_path10: "",
        d_order1: "", d_weight1: "", d_path1: "", 
        d_order2: "", d_weight2: "", d_path2: "", 
        d_order3: "", d_weight3: "", d_path3: "", 
        d_order4: "", d_weight4: "", d_path4: "", 
        d_order5: "", d_weight5: "", d_path5: "", 
        d_order6: "", d_weight6: "", d_path6: "", 
        d_order7: "", d_weight7: "", d_path7: "", 
        d_order8: "", d_weight8: "", d_path8: "", 
        d_order9: "", d_weight9: "", d_path9: "", 
        d_order10: "", d_weight10: "", d_path10: "" 
    });
    const {
        m_order1, m_weight1, m_path1,
        m_order2, m_weight2, m_path2, 
        m_order3, m_weight3, m_path3, 
        m_order4, m_weight4, m_path4, 
        m_order5, m_weight5, m_path5, 
        m_order6, m_weight6, m_path6, 
        m_order7, m_weight7, m_path7, 
        m_order8, m_weight8, m_path8, 
        m_order9, m_weight9, m_path9, 
        m_order10, m_weight10, m_path10 } = mobileValues;
    const {
        d_order1, d_weight1, d_path1,
        d_order2, d_weight2, d_path2, 
        d_order3, d_weight3, d_path3, 
        d_order4, d_weight4, d_path4, 
        d_order5, d_weight5, d_path5, 
        d_order6, d_weight6, d_path6, 
        d_order7, d_weight7, d_path7, 
        d_order8, d_weight8, d_path8, 
        d_order9, d_weight9, d_path9, 
        d_order10, d_weight10, d_path10 } = desktopValues;
    const [formMessage, setFormMessage] = useState('')
    const [updating, setUpdating] = useState(false)
    const [processing, setProcessing] = useState(false)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [pathOptions, setPathOptions] = useState([])
    const [mobileRoutes, setMobileRoutes] = useState([])
    const [desktopRoutes, setDesktopRoutes] = useState([])

    const [geo, setGeo] = useState('')
    const [geoSet, setGeoSet] = useState(false)

    const [dataChanged, setDataChanged] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    
    const orderOptions = [{'ID': 1, 'NAME': 1},{'ID': 2, 'NAME': 2},{'ID': 3, 'NAME': 3},{'ID': 4, 'NAME': 4},{'ID': 5, 'NAME': 5},{'ID': 6, 'NAME': 6},{'ID': 7, 'NAME': 7},{'ID': 8, 'NAME': 8},{'ID': 9, 'NAME': 9},{'ID': 10, 'NAME': 10}]

    useEffect(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_geo_subpid_list, { 'requester': userID, 'cascadeType': cascadeType })
                if(data.error) {
                    setCascadeError(data.error)
                } else {
                    setMobileRoutes(data.mobile)
                    setDesktopRoutes(data.desktop)
                    setPathOptions(data.options)
                    setCascadeError("")
                }
            }
        }
        //if(cascadeType > 0 {
            getDetails()
        //}
    }, [userID,cascadeType])


    useEffect(() => {
        const performUpdate = async () => {
            setProcessing(true)

            const data = await toolsAPICall(tool_geo_subpid_save, {...mobileValues, ...desktopValues, ...{ 'cascadeType': cascadeType, 'geo': geo}})
            if(data.error) {
                setFormMessage(data.error)
            } 
            else if(data.mobile) {
                setMobileRoutes(data.mobile)
                setDesktopRoutes(data.desktop)
                setFormMessage("Routine Updates complete")
            }
            setUpdating(false)
            setProcessing(false)
            setDataChanged(false)
        }
        
        if((geo).length > 0 && updating && !processing) {
            performUpdate()
        }
    }, [geo, cascadeType, mobileValues, desktopValues, updating, processing])

    const loadGeo = () => {
        setGeoSet(false)

        //set defaults
        setMobileValues({ 
            m_order1: 1, m_weight1: 10, m_path1: '0', 
            m_order2: 0, m_weight2: 10, m_path2: '0', 
            m_order3: 0, m_weight3: 10, m_path3: '0', 
            m_order4: 0, m_weight4: 10, m_path4: '0', 
            m_order5: 0, m_weight5: 10, m_letspath5: '0', 
            m_order6: 0, m_weight6: 10, m_path6: '0', 
            m_order7: 0, m_weight7: 10, m_path7: '0', 
            m_order8: 0, m_weight8: 10, m_path8: '0', 
            m_order9: 0, m_weight9: 10, m_path9: '0', 
            m_order10: 0, m_weight10: 10, m_path10: '0' })
        setDesktopValues({ 
            d_order1: 1, d_weight1: 10, d_path1: '0', 
            d_order2: 0, d_weight2: 10, d_path2: '0', 
            d_order3: 0, d_weight3: 10, d_path3: '0', 
            d_order4: 0, d_weight4: 10, d_path4: '0', 
            d_order5: 0, d_weight5: 10, d_path5: '0', 
            d_order6: 0, d_weight6: 10, d_path6: '0', 
            d_order7: 0, d_weight7: 10, d_path7: '0', 
            d_order8: 0, d_weight8: 10, d_path8: '0', 
            d_order9: 0, d_weight9: 10, d_path9: '0', 
            d_order10: 0, d_weight10: 10, d_path10: '0' })

        //look for the subpid in array
        let mobile = mobileRoutes[geo] ?? []
        if(mobile !== undefined && mobile.length > 0) {

            if(mobile.length > 0) {
                mobile.forEach((row, rid) => {
                    console.log(rid)
                    if(parseInt(rid) === 0) { 
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path1: row.pathid,
                            m_order1: row.order,
                            m_weight1: row.weight,
                        }));
                    }
                    else if(parseInt(rid) === 1) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path2: row.pathid,
                            m_order2: row.order,
                            m_weight2: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 2) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path3: row.pathid,
                            m_order3: row.order,
                            m_weight3: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 3) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path4: row.pathid,
                            m_order4: row.order,
                            m_weight4: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 4) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path5: row.pathid,
                            m_order5: row.order,
                            m_weight5: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 5) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path6: row.pathid,
                            m_order6: row.order,
                            m_weight6: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 6) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path7: row.pathid,
                            m_order7: row.order,
                            m_weight7: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 7) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path8: row.pathid,
                            m_order8: row.order,
                            m_weight8: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 8) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path9: row.pathid,
                            m_order9: row.order,
                            m_weight9: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 9) {
                        setMobileValues((prev) => ({
                            ...prev,
                            m_path10: row.pathid,
                            m_order10: row.order,
                            m_weight10: row.weight,
                        }));
                    } 
                });
                setPaths(paths)
            }
        }

        let desktop = desktopRoutes[geo] ?? []
        if(desktop !== undefined && desktop.length > 0) {

            if(desktop.length > 0) {
                desktop.forEach((row, rid) => {
                    if(parseInt(rid) === 0) { 
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path1: row.pathid,
                            d_order1: row.order,
                            d_weight1: row.weight,
                        }));
                    }
                    else if(parseInt(rid) === 1) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path2: row.pathid,
                            d_order2: row.order,
                            d_weight2: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 2) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path3: row.pathid,
                            d_order3: row.order,
                            d_weight3: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 3) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path4: row.pathid,
                            d_order4: row.order,
                            d_weight4: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 4) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path5: row.pathid,
                            d_order5: row.order,
                            d_weight5: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 5) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path6: row.pathid,
                            d_order6: row.order,
                            d_weight6: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 6) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path7: row.pathid,
                            d_order7: row.order,
                            d_weight7: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 7) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path8: row.pathid,
                            d_order8: row.order,
                            d_weight8: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 8) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path9: row.pathid,
                            d_order9: row.order,
                            d_weight9: row.weight,
                        }));
                    } 
                    else if(parseInt(rid) === 9) {
                        setDesktopValues((prev) => ({
                            ...prev,
                            d_path10: row.pathid,
                            d_order10: row.order,
                            d_weight10: row.weight,
                        }));
                    } 
                });
                setPaths(paths)
            }
        }
        setGeoSet(true)
        setDataChanged(false)
    }

    const updateRoutine = (e) => {
        e.preventDefault()
        setFormMessage("")

        const m_uniquePaths = [...new Set([m_path1,m_path2,m_path3,m_path4,m_path5,m_path6,m_path7,m_path8,m_path9,m_path10].map(item => item))]; // [ 'A', 'B']
        if(m_uniquePaths.length <= 1) {
            setFormMessage("Please select at least one Mobile Path to use")
            return
        }
        const d_uniquePaths = [...new Set([d_path1,d_path2,d_path3,d_path4,d_path5,d_path6,d_path7,d_path8,d_path9,d_path10].map(item => item))]; // [ 'A', 'B']
        if(d_uniquePaths.length <= 1) {
            setFormMessage("Please select at least one Desktop Path to use")
            return
        }

        setUpdating(true)
    }

    const handleMobileChange = (e) => {
        const { name, value } = e.target;
        setMobileValues((prev) => ({
          ...prev,
          [name]: value,
        }));
        setDataChanged(true)
    };

    const handleDesktopChange = (e) => {
        const { name, value } = e.target;
        setDesktopValues((prev) => ({
          ...prev,
          [name]: value,
        }));
        setDataChanged(true)
    };
    
    const handleError = (field, error) => {
          setErrors((prev) => ({
              ...prev,
              [field]: error,
          }));
    };

    const mobilePathsFor = (num) => {
        let pathids = []
        switch(num) {
            case 1: pathids = [m_path2,m_path3,m_path4,m_path5,m_path6,m_path7,m_path8,m_path9,m_path10]; break;
            case 2: pathids = [m_path1,m_path3,m_path4,m_path5,m_path6,m_path7,m_path8,m_path9,m_path10]; break;
            case 3: pathids = [m_path1,m_path2,m_path4,m_path5,m_path6,m_path7,m_path8,m_path9,m_path10]; break;
            case 4: pathids = [m_path1,m_path2,m_path3,m_path5,m_path6,m_path7,m_path8,m_path9,m_path10]; break;
            case 5: pathids = [m_path1,m_path2,m_path3,m_path4,m_path6,m_path7,m_path8,m_path9,m_path10]; break;
            case 6: pathids = [m_path1,m_path2,m_path3,m_path4,m_path5,m_path7,m_path8,m_path9,m_path10]; break;
            case 7: pathids = [m_path1,m_path2,m_path3,m_path4,m_path5,m_path6,m_path8,m_path9,m_path10]; break;
            case 8: pathids = [m_path1,m_path2,m_path3,m_path4,m_path5,m_path6,m_path7,m_path9,m_path10]; break;
            case 9: pathids = [m_path1,m_path2,m_path3,m_path4,m_path5,m_path6,m_path7,m_path8,m_path10]; break;
            case 10: pathids = [m_path1,m_path2,m_path3,m_path4,m_path5,m_path6,m_path7,m_path8,m_path9]; break;
            default: return pathOptions;
        }
        return pathOptions.filter(item => !pathids.includes(item.ID));
    }
    const desktopPathsFor = (num) => {
        let pathids = []
        switch(num) {
            case 1: pathids = [d_path2,d_path3,d_path4,d_path5,d_path6,d_path7,d_path8,d_path9,d_path10]; break;
            case 2: pathids = [d_path1,d_path3,d_path4,d_path5,d_path6,d_path7,d_path8,d_path9,d_path10]; break;
            case 3: pathids = [d_path1,d_path2,d_path4,d_path5,d_path6,d_path7,d_path8,d_path9,d_path10]; break;
            case 4: pathids = [d_path1,d_path2,d_path3,d_path5,d_path6,d_path7,d_path8,d_path9,d_path10]; break;
            case 5: pathids = [d_path1,d_path2,d_path3,d_path4,d_path6,d_path7,d_path8,d_path9,d_path10]; break;
            case 6: pathids = [d_path1,d_path2,d_path3,d_path4,d_path5,d_path7,d_path8,d_path9,d_path10]; break;
            case 7: pathids = [d_path1,d_path2,d_path3,d_path4,d_path5,d_path6,d_path8,d_path9,d_path10]; break;
            case 8: pathids = [d_path1,d_path2,d_path3,d_path4,d_path5,d_path6,d_path7,d_path9,d_path10]; break;
            case 9: pathids = [d_path1,d_path2,d_path3,d_path4,d_path5,d_path6,d_path7,d_path8,d_path10]; break;
            case 10: pathids = [d_path1,d_path2,d_path3,d_path4,d_path5,d_path6,d_path7,d_path8,d_path9]; break;
            default: return pathOptions;
        }
        return pathOptions.filter(item => !pathids.includes(item.ID));
    }

    const filterGeo = (e) => {
        let { value } = e.target;
        setGeo(value)
    }

    const releaseGeo = (e) => {
        if(dataChanged) {
            setShowConfirm(true)
        } else {
            setGeoSet(false)
        }
    }
    
    /*
    const updatePaths = (path, value) => {
        paths[path] = value
        setPaths(paths)
        console.table(paths)
    }
    */

    if(!tool) return <></>
    else if(cascadeError.length > 0) 
        return (
            <>
            <Breadcrumb>
              <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
              <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
            </Breadcrumb>
            <Row>
                <Col md={12}>
                    <Card>
                    <CascadeToolToggle title={tool.tool_name} description="Select a Geo to view and manage routes" value={cascadeType} onChange={(e) => setCascadeType(e.target.value)} />
                        <Row>
                            <Col md={12} className="text-center">{cascadeError}</Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            </>
        )

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
            <Col md={12}>
                <Card>
                <CascadeToolToggle title={tool.tool_name} description="Select a Geo to view and manage routes" value={cascadeType} onChange={handleDesktopChange} />
                    <Row>
                        <Col md={6} className="text-center p-4">
                            <Select
                                value={geo}
                                label="Geo"
                                name="geo"
                                formField="geos"
                                useDefault={true}
                                onChange={filterGeo} 
                                validate="required"
                                colSize="8"
                                readOnly={geoSet}
                            />
                        </Col>
                        <Col md={4} className="text-left p-4">
                        {geoSet && 
                          <Button onClick={releaseGeo} title="Change Geo" className="success" /> }
                        {!geoSet && 
                        <Button onClick={loadGeo} title="Select Geo" className="primary" /> }
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        {geoSet && 
        <Form title={`Default Routes for ${geo}`} description={tool.description} onSubmit={updateRoutine}> 
        <Row>
            <Col xl={6}> 
                <Card.Body>
                    <Row>
                        <Col md={4} className="control-label col-form-label">Routine Geo</Col>
                        <Col md={8} sm={8}>
                            <FormControl aria-label="Routine Geo" type="text" name="geo" id="geo" value={geo} readOnly={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={4} className="control-label col-form-label">Device(s)</Col>
                        <Col md={8} sm={8}>
                            <select name="devicetype" id="devicetype" className="form-control" readOnly={true}>
                                <option value="mobile">Mobile Only</option>
                            </select>
                        </Col>
                    </Row>

                    <Row className="">
                    <Col md={2} className="control-label col-form-label"><strong>Order</strong></Col>
                    <Col md={3} className="control-label col-form-label"><strong>Weight</strong></Col>
                    <Col md={7} className="text-left control-label"><strong>Offer</strong></Col>
                    </Row>

                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order1} name="m_order1" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight1} placeholder="Weight" name="m_weight1" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path1} name="m_path1" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(1)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order2} name="m_order2" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight2} placeholder="Weight" name="m_weight2" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path2} name="m_path2" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(2)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order3} name="m_order3" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight3} placeholder="Weight" name="m_weight3" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path3} name="m_path3" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(3)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order4} name="m_order4" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight4} placeholder="Weight" name="m_weight4" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path4} name="m_path4" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(4)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order5} name="m_order5" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight5} placeholder="Weight" name="m_weight5" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path5} name="m_path5" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(5)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order6} name="m_order6" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight6} placeholder="Weight" name="m_weight6" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path6} name="m_path6" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(6)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order7} name="m_order7" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight7} placeholder="Weight" name="m_weight7" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path7} name="m_path7" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(7)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order8} name="m_order8" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight8} placeholder="Weight" name="m_weight8" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path8} name="m_path8" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(8)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order9} name="m_order9" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight9} placeholder="Weight" name="weight9" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path9} name="m_path9" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(9)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={m_order10} name="m_order10" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={m_weight10} placeholder="Weight" name="m_weight10" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={m_path10} name="m_path10" onChange={handleMobileChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={mobilePathsFor(10)} useDefault={true} />
                        </Col>
                    </Row>

                </Card.Body>
            </Col>
            <Col xl={6}> 
                <Card.Body>
                    <Row>
                        <Col md={4} className="control-label col-form-label">Routine Geo</Col>
                        <Col md={8} sm={8}>
                            <FormControl aria-label="Routine Geo" type="text" name="geo" id="geo" value={geo} readOnly={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={4} className="control-label col-form-label">Device(s)</Col>
                        <Col md={8} sm={8}>
                            <select name="devicetype" id="devicetype" className="form-control" readOnly={true} >
                                <option value="desktop">Desktop Only</option>
                            </select>
                        </Col>
                    </Row>
                    <Row className="">
                        <Col md={2} className="control-label col-form-label"><strong>Order</strong></Col>
                        <Col md={3} className="control-label col-form-label"><strong>Weight</strong></Col>
                        <Col md={7} className="text-left control-label"><strong>Offer</strong></Col>
                    </Row>

                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order1} name="d_order1" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight1} placeholder="Weight" name="d_weight1" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path1} name="d_path1" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(1)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order2} name="d_order2" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight2} placeholder="Weight" name="d_weight2" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path2} name="d_path2" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(2)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order3} name="d_order3" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight3} placeholder="Weight" name="d_weight3" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path3} name="d_path3" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(3)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order4} name="d_order4" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight4} placeholder="Weight" name="d_weight4" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path4} name="d_path4" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(4)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order5} name="d_order5" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight5} placeholder="Weight" name="d_weight5" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path5} name="d_path5" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(5)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order6} name="d_order6" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight6} placeholder="Weight" name="d_weight6" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path6} name="d_path6" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(6)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order7} name="d_order7" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight7} placeholder="Weight" name="d_weight7" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path7} name="d_path7" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(7)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order8} name="d_order8" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight8} placeholder="Weight" name="d_weight8" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path8} name="d_path8" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(8)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order9} name="d_order9" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight9} placeholder="Weight" name="d_weight9" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path9} name="d_path9" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(9)} useDefault={true} />
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col md={2} className="">
                            <Select value={d_order10} name="d_order10" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={orderOptions} useDefault={true} />
                        </Col>
                        <Col md={3} className="">
                            <Input type="number" value={d_weight10} placeholder="Weight" name="d_weight10" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize="12" readOnly={updating} />
                        </Col>
                        <Col md={7} sm={8}>
                        <Select value={d_path10} name="d_path10" onChange={handleDesktopChange} onError={handleError} validate="required|numeric" colSize={12} readOnly={updating} formValues={desktopPathsFor(10)} useDefault={true} />
                        </Col>
                    </Row>
                </Card.Body>
            </Col>
        </Row>
        <Row>
            <Col md={12} className="text-center pt-5">
                <Card.Text>{formMessage ?? errors ?? ""}</Card.Text>
                {!updating ? <Button title="Update Default Routes" className="primary" /> : null}
            </Col>
        </Row>
        </Form>
        }
        <ConfirmDialog
            show={showConfirm}
            title="Change Geo" message="Are you sure you wish to change Geos? Any unsaved changes will be lost"
            onClose={() => { setShowConfirm(false) }}
            onConfirm={() => { setGeoSet(false); setShowConfirm(false) }}
        />
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(GeoDefaultSubpidTool), "Cascade Geo Route Management"));